// ToasterContainer.jsx
import React from 'react';
import { useData } from '../dataContext';
import Toaster from './toaster';
import Configs from '../../Configs';

/**
 * Container component that handles multiple toasts
 * This component should be placed once in your app layout
 */
function ToasterContainer() {
  const { toasterMessages } = useData();

  if (!toasterMessages || toasterMessages.length === 0) {
    return null;
  }

  return (
    <div className="fixed top-4 right-4 lg:top-20 lg:right-6 z-[100] space-y-2 pointer-events-none">
      {toasterMessages.map((message, index) => (
        <div 
          key={message.id}
          className="pointer-events-auto"
          style={{
            animationDelay: `${index * 100}ms`,
            transform: `translateY(${index * -8}px)` // Slight stagger effect
          }}
        >
          <Toaster
            message={message}
            timeout={message.persistent ? 0 : Configs.toasterTimeout}
            position="relative"
            onClose={() => {
              // This will be handled by the individual Toaster component
            }}
          />
        </div>
      ))}
    </div>
  );
}

export default ToasterContainer;